export default __webpack_public_path__ + "static/media/altered_up.43c787c8.svg";